import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'button' ]

  checked(e) {
    this.buttonTarget.style = e.currentTarget.checked ? 'display:block' : 'display:none'
  }
}
